import { cva } from '@vizit/theme';

const usersTableWrapperClasses = cva({
  base: ['flex flex-col gap-4'],
});

const tableContainerClasses = cva({
  base: ['overflow-auto border border-gray-200 max-h-screen'],
});

const tableClasses = cva({
  base: ['w-full border-collapse'],
});

export { usersTableWrapperClasses, tableContainerClasses, tableClasses };
